import { cn } from "@/utils/cn";
import { CgSpinnerTwoAlt } from "react-icons/cg";

export default function Button({
  title,
  variant = "primary",
  onClick,
  loading,
}) {
  return (
    <button
      disabled={!!loading}
      onClick={onClick}
      className={cn(
        "bg-primary text-white py-3 w-full rounded-full font-semibold text-base flex justify-center items-center",
        variants[variant],
        !!loading && "opacity-75"
      )}
    >
      {!!!loading ? (
        title
      ) : (
        <CgSpinnerTwoAlt size={25} color="white" className="animate-spin" />
      )}
    </button>
  );
}

const variants = {
  primary: "bg-primary text-white",
  secondary: "border-2 bg-white border-[#DEDFDD] text-black",
};
